import { localeShortDateTime } from "../app/datetimeUtils";

export interface Props {
	date: Date | string | undefined;
}

export default function FormattedDateAndTime({ date }: Props) {
	// results in MM/DD/YY HH:MM AM/PM
	return date == undefined ? null : <>{localeShortDateTime(date)}</>;
}
